import { BREAKPOINTS, CONFIG } from './../config';
import getEventHandlerResize from '../ResizeHandler';

class BfvStageNewsCompact {
  constructor(options = {}) {
    this.$root = options.element;
    this.$stage = this.$root.querySelector('.js-stage');
    this.$newsCompact = this.$root.querySelector('.js-news-compact');
    this.$newsEntries = this.$newsCompact.querySelector('.js-news-entries');
    this.$newsEntriesWrapper = this.$newsCompact.querySelector('.js-news-entries-wrapper');
    this.$scrollUpButton = this.$newsCompact.querySelector('.js-scroll-up');
    this.$scrollDownButton = this.$newsCompact.querySelector('.js-scroll-down');
    this.$loadMoreButton = this.$newsCompact.querySelector('.js-load-more-button');

    this.currentBreakpointKey = getEventHandlerResize().getCurrentViewport();
  }

  init() {
    this.setNewsCompactMaxHeight();

    this.bindClickEvents();

    window.addEventListener(CONFIG.events.RESIZE, () => {
      this.setNewsCompactMaxHeight();
    });

    window.addEventListener(CONFIG.events.VIEWPORT_CHANGED, (event) => {
      this.currentBreakpointKey = event.detail.viewport;
      if (this.currentBreakpointKey !== BREAKPOINTS.large) {
        if (this.$scrollUpButton.style.display !== 'none') {
          this.$scrollUpButton.style.display = 'none';
        }
        if (this.$scrollDownButton.style.display !== 'none') {
          this.$scrollDownButton.style.display = 'none';
        }
      } else {
        this.resetScrollPosition();
      }
    });
  }

  bindClickEvents() {
    this.$scrollUpButton.addEventListener('click', () => {
      this.scrollUp();
    });

    this.$scrollDownButton.addEventListener('click', () => {
      this.scrollDown();
    });

    this.$loadMoreButton.addEventListener('click', () => {
      this.$newsCompact.classList.remove('bfv-news-compact--half-hidden');
    });
  }

  /**
   * On viewport L, limits the news compact module to the height of the stage
   * On viewports XS and M resets the limit if existent
   */
  setNewsCompactMaxHeight() {
    if (this.currentBreakpointKey === BREAKPOINTS.large) {
      this.$newsCompact.style.maxHeight = `${this.$stage.getBoundingClientRect().height}px`;

      const wrapperHeight = this.$stage.getBoundingClientRect().height -
        this.$newsEntriesWrapper.offsetTop;
      this.$newsEntriesWrapper.style.maxHeight = `${wrapperHeight}px`;

      this.resetScrollPosition();
    } else {
      this.unsetMaxHeight(this.$newsCompact);
      this.unsetMaxHeight(this.$newsEntriesWrapper);
      if (parseInt(this.$newsEntries.style.top, 10) !== 0) {
        this.$newsEntries.style.top = 0;
      }
    }
  }

  // noinspection JSMethodCanBeStatic
  /**
   * unset the max height, if set
   * @param $element
   */
  unsetMaxHeight($element) {
    if ($element.style.maxHeight !== 'unset') {
      // noinspection UnnecessaryLocalVariableJS
      const $el = $element;
      $el.style.maxHeight = 'unset';
    }
  }

  /**
   * resets the scrolling position of the news compact position to top or bottom
   */
  resetScrollPosition() {
    if (this.isScrolledDown) {
      this.scrollDown();
    } else {
      this.scrollUp();
    }
  }

  /**
   * scroll down the news compact entries
   */
  scrollDown() {
    this.$scrollUpButton.style.display = 'flex';

    const contentHeight = this.$newsEntries.getBoundingClientRect().height;
    const wrapperHeight = this.$newsEntriesWrapper.getBoundingClientRect().height;
    const contentTop = parseInt(this.$newsEntries.style.top, 10);
    const scrollUpButtonHeight = this.$scrollUpButton.getBoundingClientRect().height;

    if (contentHeight + contentTop <= wrapperHeight * 2) {
      this.$newsEntries.style.top = `${(
        wrapperHeight - contentHeight
      )}px`;

      this.$scrollDownButton.style.display = 'none';
      this.isScrolledDown = true;
    } else {
      this.$newsEntries.style.top = `${(
        contentTop - this.$newsEntriesWrapper.getBoundingClientRect().height + scrollUpButtonHeight
      )}px`;
    }
  }

  /**
   * scroll up the news compact entries
   */
  scrollUp() {
    this.$scrollDownButton.style.display = 'flex';

    const wrapperHeight = this.$newsEntriesWrapper.getBoundingClientRect().height;
    const contentTop = parseInt(this.$newsEntries.style.top || 0, 10);
    const scrollDownButtonHeight = this.$scrollDownButton.getBoundingClientRect().height;

    // noinspection JSSuspiciousNameCombination
    if (Math.abs(contentTop) <= wrapperHeight) {
      this.$newsEntries.style.top = 0;
      this.$scrollUpButton.style.display = 'none';
    } else {
      this.$newsEntries.style.top = `${(
        contentTop + this.$newsEntriesWrapper.getBoundingClientRect().height - scrollDownButtonHeight
      )}px`;
    }

    this.isScrolledDown = false;
  }
}

export default BfvStageNewsCompact;



// WEBPACK FOOTER //
// ./src/javascript/main/BfvStageNewsCompact/index.js